export default __webpack_public_path__ + "static/media/userIcon.060e44b1.svg";